// built-from: /feature-flags v1 impl:feature-flags role:implementation
// Beta-feature gate. Delivery and VSM are kept in the codebase but
// hidden behind this flag — off by default. Flip on locally/in an env
// with REACT_APP_BETA_FEATURES=true (CRA inlines REACT_APP_* at build).
export function isBetaEnabled(): boolean {
  return process.env.REACT_APP_BETA_FEATURES === 'true';
}

// Deprecated programme surfaces are retained only as a reversible rollback
// path while the modernisation engagement replaces them. The positive flag is
// deliberately opt-in: a missing or malformed value keeps legacy UI hidden.
export function isLegacySurfacesEnabled(): boolean {
  return process.env.REACT_APP_LEGACY_SURFACES === 'true';
}
